import { useState } from 'react';
import { SupplierFeatureInputView } from './SupplierFeatureInputView';
import { SupplierSelectionPanel } from './SupplierSelectionPanel';
import { useEngagementEditor } from './EngagementEditorContext';

/** The Supplier Selection tab: the shortlist, and the shortlisted suppliers' feature input opened from it. */
export const SupplierSelectionTab = () => {
  const { flushSaves, featureInput } = useEngagementEditor();
  const [showFeatureInput, setShowFeatureInput] = useState(false);

  // The view reads the shortlist and the matrix ticks from the API, so it loads and opens only once every edit has saved.
  const openFeatureInput = async () => {
    if (flushSaves && !(await flushSaves())) return;
    featureInput?.loadFresh();
    setShowFeatureInput(true);
  };

  return showFeatureInput && featureInput ? (
    <SupplierFeatureInputView
      answers={featureInput}
      onBack={() => setShowFeatureInput(false)}
    />
  ) : (
    <SupplierSelectionPanel onReviewFeatureInput={openFeatureInput} />
  );
};
